import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import useSideBarStyles from './useSideBarStyles';
import SideSheet from './SideSheet/SideSheet';

const SideBar = (props) => {
    const classes = useSideBarStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <nav className={classes.sideBar} aria-label="Public Transportation Routes">
            {/** Mobile SideBar */}
            {isMobile?
                <Drawer
                    classes={{
                        paper: classes.drawerPaper
                    }}
                    variant="temporary"
                    anchor={theme.direction === 'rtl'? 'right' : 'left'}
                    open={props.open}
                    onClose={props.onClose}
                    ModalProps={{
                        keepMounted: true // Better open performance on mobile
                    }}
                >
                    <SideSheet />
                </Drawer>
            :
                <Drawer
                    classes={{
                        paper: classes.drawerPaper
                    }}
                    variant="permanent" 
                    open>
                        <SideSheet />
                </Drawer>
            }
        </nav>
    );
};

export default SideBar;